/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type Views } from '@/features/account/context/account_view_context';

export const noBackOnAutoSubmit = new Set<Views>([
  'password',
  'email_otp_code',
  'sms_otp_code',
  'auto_email_otp_code',
  'auto_sms_otp_code',
  'create_account',
  'login',
]);

export const noBackViews = new Set<Views>([
  'login',
  'create_new_password',
  'keep_current_password',
]);
